import axios from "axios";
import { SERVER } from "../../Constants";

const apiClient = axios.create({
  baseURL: SERVER,
  withCredentials: true,
});

export const getTestimonialStats = async () => {
  try {
    const response = await apiClient.get("/testimonials/admin/stats");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch testimonial stats");
  }
};

export const getTestimonialPendingCount = async () => {
  try {
    const response = await apiClient.get("/testimonials/admin/pending-count");
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch pending count");
  }
};

export const getTestimonialList = async (params = {}) => {
  try {
    const response = await apiClient.get("/testimonials/admin/list", { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch testimonials");
  }
};

export const getTestimonialById = async (testimonialId) => {
  try {
    const response = await apiClient.get(`/testimonials/admin/${testimonialId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch testimonial");
  }
};

export const reviewTestimonial = async (testimonialId, body) => {
  try {
    const response = await apiClient.post(`/testimonials/admin/review/${testimonialId}`, body);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to review testimonial");
  }
};

export const publishTestimonial = async (testimonialId, body = {}) => {
  try {
    const response = await apiClient.post(`/testimonials/admin/publish/${testimonialId}`, body);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to publish testimonial");
  }
};

export const unpublishTestimonial = async (testimonialId) => {
  try {
    const response = await apiClient.post(`/testimonials/admin/unpublish/${testimonialId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to unpublish testimonial");
  }
};

export const deleteTestimonial = async (testimonialId) => {
  try {
    const response = await apiClient.delete(`/testimonials/admin/${testimonialId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete testimonial");
  }
};

export const featureTestimonial = async (testimonialId, body) => {
  try {
    const response = await apiClient.patch(`/testimonials/admin/${testimonialId}/feature`, body);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update feature settings");
  }
};

export const reorderTestimonials = async (items) => {
  try {
    const response = await apiClient.post("/testimonials/admin/reorder", { items });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to reorder testimonials");
  }
};
